import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import SignatureScreen from '../../../../../components/SignatureScreen.vue'
export default {
  props: {
    institutionId: String,
    serviceOrderId: String,
  },

  components: {
    SignatureScreen,
  },

  async created() {
    this.env = process.env.VUE_APP_BASE_URL
    this.currentUser = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    if (this.serviceOrderId) {
      await this.getServiceOrder(this.serviceOrderId)
    }
    console.log(this.currentServiceOrder)
  },

  data: () => ({
    institution: {},
    loading: false,
    option: 0,
    signatureConfirmDialog: false,
    env: '',
    signatureErrorDialog: false,
    executingSignatureImage: null,
    validatorSignatureImage: null,
    serviceOrderInternalTypes: [
      'Treinamento',
      'Segurança elétrica',
      'Preventiva',
      'Instalação',
      'Rotina de Inspeção',
      'Corretiva',
      'Calibração',
      'Validação/Qualificação',
      'Serviço Administrativo',
      'Empréstimo',
      null,
      'Obras',
      'Serviço Operacional',
    ],
    categories: ['Equipamento', 'Setor'],
    causeDefects: [
      'Não aplicável',
      'Falha intrínseca',
      'Falha infraestrutura',
      'Erro operacional',
      'Dano acidental',
      'Abuso na utilização',
    ],
    statusStep: [
      'Manutenção terceirizada in loco',
      'Manutenção terceirizada externa',
      'Manutenção interna',
      'Aguardando peça',
      'Aguardando orçamento',
      'Aguardando avaliação externa',
      'Aguardando aprovação de orçamento',
      'Aguardando liberação do setor',
      'Deslocamento',
      'Equipamento não encontrado',
      'Aguardando Solicitação/Ordem de Compra',
    ],
    currentServiceOrder: {},
    currentUser: {},
    apiService: new ApiService(),
  }),

  methods: {
    getCalled() {
      this.apiService
        .get(`called/getCalled/${this.currentServiceOrder.id}`)
        .then((response) => {
          this.called = response.content
          this.currentServiceOrder.urgency = this.getUrgencyCalledClass(
            this.called.calledLevelUrgent
          )
        })
    },

    getCriticalityLevel() {
      let functionScore = 0
      let riskScore = 0
      let indexAbcScore = 0

      switch (
        this.currentServiceOrder.equipment.standardEquipment.functionEquipment
      ) {
        case 4:
          functionScore = 10
          break
        case 5:
          functionScore = 8
          break
        case 2:
          functionScore = 6
          break
        case 1:
          functionScore = 4
          break
        case 3:
          functionScore = 2
          break
        default:
          functionScore = 0
          break
      }

      switch (
        this.currentServiceOrder.equipment.standardEquipment.equipmentRisk
      ) {
        case 2:
          riskScore = 7
          break
        case 1:
          riskScore = 5
          break
        case 4:
          riskScore = 3
          break
        case 3:
          riskScore = 1
          break
        default:
          riskScore = 0
          break
      }

      switch (this.currentServiceOrder.equipment.degreeImportance) {
        case 'A':
          indexAbcScore = 10
          break
        case 'B':
          indexAbcScore = 5
          break
        default:
          indexAbcScore = 0
          break
      }

      const criticality = functionScore + riskScore + indexAbcScore
      if (criticality >= 3 && criticality < 12) {
        return 'Baixa'
      } else if (criticality >= 12 && criticality < 19) {
        return 'Média'
      } else if (criticality >= 19) {
        return 'Alta'
      }
    },

    getUrgencyCalledClass(urgency) {
      switch (urgency) {
        case 0:
          return 'Alta'
        case 1:
          return 'Média'
        case 2:
          return 'Baixa'
        default:
          return ''
      }
    },

    async getEquipmentById() {
      if (this.currentServiceOrder.equipmentId) {
        await this.apiService
          .get(
            `equipment/${this.institutionId}/${this.currentServiceOrder.equipmentId}`,
            null,
            true,
            false
          )
          .then((response) => {
            this.equipmentSelected = response.content
            this.unidadeId = response.content.unidadeId
            this.currentServiceOrder.equipment = this.equipmentSelected
            if (response.content.costCenterId != null) {
              this.costCenterId = response.content.costCenterId
              this.costCenterName = response.content.costCenter.name
            }
          })
      }
      await this.getDepartment()
      this.getCostCenter()
    },

    async getServices() {
      this.servicesLoading = true
      await this.apiService
        .get(`service/list/${this.currentServiceOrder.id}`, null, true, false)
        .then((response) => {
          this.currentServiceOrder.services = response.content
          this.servicesLoading = false
        })
    },

    async getDepartment() {
      this.departmentId = this.equipmentSelected.departmentId
      this.currentServiceOrder.subDepartmentId =
        this.equipmentSelected.subDepartmentId
      await this.apiService
        .get(`department/${this.departmentId}`, null, true, false)
        .then((response) => {
          this.departmentName = response.content.name
        })
    },

    getCostCenter() {
      if (this.costCenterId == null) {
        const costCenter = this.costCenters
          ? this.costCenters.find(
              (x) => x.departmentId === this.equipmentSelected.departmentId
            )
          : null
        if (costCenter) {
          this.costCenterId = costCenter.id
          this.costCenterName = costCenter.name
        }
      }
    },

    async removeValidateServiceOrder() {
      let valid = false

      if (
        this.institution.userType == 2 ||
        this.currentUser.mainType == 1 ||
        this.institution.userType == 8 ||
        this.currentUser.mainType == 0
      ) {
        valid = true
      }

      if (this.currentUser.id == this.currentServiceOrder.validatorUserId) {
        valid = true
      }

      if (valid) {
        this.currentServiceOrder.isValidatorSigned = false
        this.currentServiceOrder.validatorUserId = null
        this.currentServiceOrder.validatorImage = null
        this.validatorSignatureImage = null

        const model = { ...this.currentServiceOrder }
        delete model.checklists
        delete model.checklistTemplate
        delete model.checklistServiceOrders

        await this.apiService
          .post('serviceOrder/edit', model)
          .then((response) => {
            if (response.statusCode == 200) {
              this.getServiceOrder(this.serviceOrderId)
            }
          })
      } else {
        this.$toast.error('Você não tem permissão para remover validações')
      }
    },

    async editServiceOrder() {
      const model = { ...this.currentServiceOrder }
      delete model.checklists
      delete model.checklistTemplate
      delete model.checklistServiceOrders
      await this.apiService
        .post('serviceOrder/edit', model)
        .then((response) => {
          if (response.statusCode == 200) {
            this.getServiceOrder(this.serviceOrderId)
          }
        })
    },

    async validateServiceOrder(data) {
      if (this.option == 0) {
        if (this.currentUser.signatureImage) {
          this.currentServiceOrder.isValidatorSigned = true
          this.currentServiceOrder.validatorUserId = this.currentUser.id
          this.currentServiceOrder.validatorImage = null
          this.signatureConfirmDialog = false
          this.editServiceOrder()
        } else {
          this.signatureErrorDialog = true
        }
      } else if (this.option == 1) {
        this.currentServiceOrder.isValidatorSigned = true
        this.currentServiceOrder.validatorUserId = this.currentUser.id
        this.currentServiceOrder.validatorImage = data
        this.editServiceOrder()
        this.signatureConfirmDialog = false
      } else {
        if (
          this.currentServiceOrder &&
          this.currentServiceOrder.responsibleName
        ) {
          this.apiService
            .get(`byName/${this.currentServiceOrder.responsibleName}`)
            .then((response) => {
              this.currentServiceOrder.isValidatorSigned = true
              this.currentServiceOrder.validatorUserId = response.content.id
              this.currentServiceOrder.validatorImage = null
              this.editServiceOrder()
              this.signatureConfirmDialog = false
            })
        } else {
          this.$toast.error(
            'Nenhum responsável encontrado na Ordem de Serviço!'
          )
        }
      }
    },

    async getServiceOrder(serviceOrderId) {
      await this.apiService
        .get(
          `serviceOrder/getServiceOrder/${this.institutionId}/${serviceOrderId}`
        )
        .then((response) => {
          this.currentServiceOrder = response.content
          if (response.content.isExecutingSigned) {
            this.getUser(response.content.executingUserId, true)
          }

          if (this.currentServiceOrder.category == 0) this.getEquipmentById()

          if (response.content.isValidatorSigned) {
            this.getUser(response.content.validatorUserId, false)
          }

          if (this.currentServiceOrder.name.includes('Chamado')) {
            this.getCalled()
          }

          this.getServices()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          if (err.status === 404) {
            this.$router.push('/serviceOrders')
          }

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getUser(userId, isExecuting) {
      await this.apiService
        .get(`user/${userId}`)
        .then((response) => {
          if (isExecuting) {
            if (response.content.signatureImage != null) {
              this.executingSignatureImage = response.content.signatureImage
            }
          } else {
            if (response.content.signatureImage != null) {
              this.validatorSignatureImage = response.content.signatureImage
            }
          }
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async generatePDF() {
      const serviceOrderPrintModel = {
        ServiceOrder: this.currentServiceOrder,
      }
      await this.apiService
        .post('serviceOrder/printServiceOrder', serviceOrderPrintModel)
        .then((response) => {
          var pdfResult = `data:application/pdf;base64,${response.content.pdf}`
          const link = document.createElement('a')
          link.href = pdfResult
          link.setAttribute(
            'download',
            `Ordem_Servico:${this.currentServiceOrder.number}_${this.formatDate(
              new Date()
            )}`
          )
          document.body.appendChild(link)
          link.click()
          this.printDialog = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          this.printDialog = false

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    formatDateTime(date) {
      if (!date) return
      return Utils.dateTime(date)
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },
  },
}
